import SetupButton from "./SetupButton.component";

export default SetupButton;
